import O1HD from "../../engines/gameEngine";
import data_control from "../../engines/libs/data_control";
import utilsView from "../../engines/libs/utilsView";
import { UI_Z_INDEX } from "../../engines/modules/uiModule";
import { CsvFileKind } from "../../modes/define/CsvFileKind";
import { MessageEventKind } from "../../modes/define/MessageEventKind";
import { BUNDLE_SMALL_NAME } from "../../modes/normalMode/BundleResourceConfig";
import chooseConcubineConcubine from "./chooseConcubineConcubine";
import concubineCompletePage from "./concubineCompletePage";

const {ccclass, property} = cc._decorator;

@ccclass
export default class chooseConcubineGame extends cc.Component {

    @property({type:cc.Label,tooltip:'标题文本'})
    lbTitle:cc.Label = null;

    @property({type:cc.Label,tooltip:'时间文本'})
    lbTime:cc.Label = null;
    
    @property({type:cc.Node,tooltip:'妃子content节点'})
    ConcubineContent:cc.Node = null;

    @property({type:cc.Node,tooltip:'按钮节点'})
    btns:cc.Node[] = [];

    @property({type:cc.Node,tooltip:'太阳节点'})
    sunNode:cc.Node = null;

    @property({type:cc.Node,tooltip:'背景节点'})
    bgNode:cc.Node = null;

    @property({type:cc.SpriteFrame,tooltip:"背景普通图片"})
    bgNormalSp:cc.SpriteFrame = null;

    @property({type:cc.SpriteFrame,tooltip:"阴天背景图片"})
    bgOvercastSp:cc.SpriteFrame = null;

    @property({type:cc.Node,tooltip:"黑幕节点"})
    blackNode:cc.Node = null;

    @property({type:cc.Prefab,tooltip:"完成预制体"})
    completePrefab:cc.Prefab = null;

    @property({type:cc.Node,tooltip:"闪电动画"})
    lightAni:cc.Node = null;

    @property({type:cc.Node,tooltip:"放大镜节点"})
    glassNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"背景节点"})
    glassBgNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"眼镜的mask节点"})
    glassMaskNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"背景大节点"})
    bigBgNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"提示视频图标"})
    hintVideo:cc.Node = null;

    @property({type:cc.Node,tooltip:"提示文字"})
    hintNode:cc.Node = null;

    goTips:boolean = false;

    questionAry:string[] = [
        "目标1:找出声音难听的丽人","目标2:找出皮肤不好的丽人","目标3:找出有体味的丽人","做出最终选择"
    ];

    questionTime:number[] = [
        60,60,60,60
    ];

    curIndex:number = 0;

    curTime:number = 0;

    curQuestionStr:string = "";

    pauseTime:boolean = false;

    start(){
        O1HD.on(MessageEventKind.EventName.SELECT_CONCUBINE_RANDSORT,this.concubineRandSort,this);
        O1HD.on(MessageEventKind.EventName.CLOSE_CONCUBINE,this.closeThis,this);
        O1HD.on(MessageEventKind.EventName.SELECT_CONCUBINE_PAUSE_STATUS,this.changePauseTime,this);
        this.blackNode.active = true;
        cc.tween(this.blackNode).delay(2).to(0.5,{opacity:0}).call(()=>{
            O1HD.getManagers().soundMgr.playMusic("chooseConcubineBgm",BUNDLE_SMALL_NAME.chooseConcubineGameBundle);
            // this.startCountDown();
            this.blackNode.active = false;
        }).start();
        this.loadGame();
        this.refrenshHintBtn();
    }

    /*
     * 加载游戏 
     */
    loadGame(){
        console.log("loadGame");
        let rTypeAry:number[] = data_control.randomSortArray([0,1,2,3,4]);
        this.ConcubineContent.children.forEach((n:cc.Node,index:number)=>{
            let ns = n.getComponent(chooseConcubineConcubine);
            let type = rTypeAry[index];
            ns.setConcubineType(type,this);
        });
        console.log(rTypeAry,"所有的人的类型")
        this.refrenshQuestion();
        this.bgNode.getComponent(cc.Sprite).spriteFrame = this.bgNormalSp;
        this.changeStep();
        this.btnAddEvent();
        console.log("loadGameEnd");
    }

    bgAddEvent(){
        // this.bigBgNode.on("touchend",this.openGlass,this);
    }

    bgRemoveEvent(){
        // this.bigBgNode.off("touchend",this.openGlass,this);
    }

    peopleAddEvent(){
        this.ConcubineContent.children.forEach((n:cc.Node,index:number)=>{
            n.on("touchend",this.checkOnePeople,this);
        });
    }

    peopleRemoveEvent(){
        this.ConcubineContent.children.forEach((n:cc.Node,index:number)=>{
            n.off("touchend",this.checkOnePeople,this);
        });
    }

    btnAddEvent(){
        this.btns.forEach((n:cc.Node)=>{
            let btnSp:cc.Node = n.getChildByName("sp");
            btnSp.on('touchstart',this.onTouchStartBtn,this);
            btnSp.on('touchmove',this.onTouchMoveBtn,this);
            btnSp.on('touchend',this.onTouchEndBtn,this);
            btnSp.on('touchcancel',this.onTouchEndBtn,this);
        });
    }

    btnRemoveEvent(){
        this.btns.forEach((n:cc.Node)=>{
            let btnSp:cc.Node = n.getChildByName("sp");
            btnSp.off('touchstart',this.onTouchStartBtn,this);
            btnSp.off('touchmove',this.onTouchMoveBtn,this);
            btnSp.off('touchend',this.onTouchEndBtn,this);
            btnSp.off('touchcancel',this.onTouchEndBtn,this);
        });
    }

    onTouchStartBtn(e:cc.Event.EventTouch){
        let nNode:cc.Node = e.target;
        if(nNode.parent.name == "btnGlass"){
            let sPos:cc.Vec2 = nNode.convertToWorldSpaceAR(cc.v2(0,0));
            let pos:cc.Vec2 = this.glassNode.parent.convertToNodeSpaceAR(sPos);
            let cPos = pos.sub(cc.v2(15,-30)).mul(this.glassBgNode.scale).neg();
            this.glassMaskNode.setPosition(pos.sub(cc.v2(15,-30)));
            this.glassNode.setPosition(pos);
            this.glassBgNode.setPosition(cPos);
            this.showGlass();
        }
    }

    onTouchMoveBtn(e:cc.Event.EventTouch){
        let detal:cc.Vec2 = e.getDelta();
        let node:cc.Node = e.target;
        node.x += detal.x;
        node.y += detal.y;
        if(node.parent.name == "btnGlass"){
            this.onTouchMoveGlass(e);
        }
    }

    onTouchEndBtn(e:cc.Event.EventTouch){
        let node:cc.Node = e.target;
        let tNode:cc.Node = null;
        this.ConcubineContent.children.forEach((n:cc.Node,index:number)=>{
            let trigger:cc.Node = n.getChildByName("trigger");
            if(trigger.getBoundingBoxToWorld().contains(node.convertToWorldSpaceAR(cc.v2()))){
                tNode = n;
            }
        });
        if(tNode && tNode.parent.name != "btnGlass"){
            this.checkPeople(tNode);
        }
        this.hideglass();
        node.setPosition(cc.v2(0,5));
    }

    refrenshQuestion(){
        this.curQuestionStr = this.questionAry[this.curIndex];
        this.curTime = this.questionTime[this.curIndex];
        this.btns.forEach((n:cc.Node)=>{
            n.active = false;
        });
        let btn = this.btns[this.curIndex];
        if(btn){
            this.btns[this.curIndex].active = true;
        }
        this.lbTitle.string = this.curQuestionStr;
        this.refrenshTime();
        this.peopleAddEvent();
        this.startCountDown();
        this.changePauseTime(false);
        O1HD.getManagers().soundMgr.playSound("nextFrame",null,BUNDLE_SMALL_NAME.chooseConcubineGameBundle);
    }

    refrenshTime(){
        this.lbTime.string = this.curTime.toString() + "S";
    }

    startCountDown(){
        this.schedule(this.subCountTime,1);
    }

    subCountTime(){
        if(this.pauseTime){
            return;
        }
        this.curTime--;
        this.refrenshTime();
        if(this.curTime <= 0){
            this.stopCountDown();
            this.timeEnd();
        }
    }

    stopCountDown(){
        this.unschedule(this.subCountTime);
    }

    /**选择完毕 */
    chooseComplete(){
        this.curIndex++;
        this.stopCountDown();
        this.refrenshQuestion();
        this.ConcubineContent.children.forEach((n:cc.Node)=>{
            let ns = n.getComponent(chooseConcubineConcubine);
            ns.initConcubine();
        });
        this.changeStep();
        // this.peopleRemoveEvent();
    }

    checkOnePeople(e:cc.Event.EventTouch){
        let people:cc.Node = e.target;
        switch(this.curIndex){
            case 1:{
                this.checkPeople(people);
                break;
            }
            case 3:{
                this.checkPeople(people);
                break;
            }
        }
    }

    checkPeople(people:cc.Node){
        let ps = people.getComponent(chooseConcubineConcubine);
        switch(this.curIndex){
            case 0:{
                ps.checkAudioFail();
                break;
            }
            case 1:{
                if(ps.checkState){
                    this.peopleRemoveEvent();
                    this.changePauseTime(true);
                    ps.showTrues().then(()=>{
                        this.chooseComplete();
                    });
                }else{
                    ps.checkskinFail();
                }
                break;
            }
            case 2:{
                ps.checkOdourFail();
                break;
            }
            case 3:{
                let eventId:string = null;
                switch(ps.getConcubineType()){
                    case 2:{
                        eventId = "46";
                        break;
                    }
                    case 3:{
                        eventId = "47";
                        break;
                    }
                    case 4:{
                        eventId = "48";
                        break;
                    }
                }
                if(eventId != null){
                    let data = {
                        id: eventId
                        , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                        , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
                    }
                    utilsView.openEventLayer(
                        null
                        , data
                        , UI_Z_INDEX.DIALOG
                    );
                }else{
                    let pp:cc.Node = cc.instantiate(this.completePrefab);
                    let pps = pp.getComponent(concubineCompletePage);
                    pps.bindType(ps.getConcubineType());
                    O1HD.Canvas().addChild(pp);
                }
                this.changePauseTime(true);
                break;
            }
        }
    }

    changeStep(){
        switch(this.curIndex){
            case 0:{

                break;
            }
            case 1:{
                this.sunNode.on('touchend',this.onTouchEndSun,this);
                this.sunNode.on('touchcancel',this.onTouchEndSun,this);
                this.bgAddEvent();
                break;
            }
            case 2:{
                // this.bgRemoveEvent();
                this.ConcubineContent.children.forEach((n:cc.Node)=>{
                    let ns = n.getComponent(chooseConcubineConcubine);
                    ns.changeState(2);
                });
                break;
            }
        }
    }

    onTouchEndSun(e:cc.Event.EventTouch){
        let startPos:cc.Vec2 = e.getStartLocation();
        let endPos:cc.Vec2 = e.getLocation();
        if(startPos.y - endPos.y > 30 || startPos.y - endPos.y < -30){
            this.sunNode.active = false;
            this.bgNode.getComponent(cc.Sprite).spriteFrame = this.bgOvercastSp;
            this.sunNode.off('touchend',this.onTouchEndSun,this);
            this.sunNode.off('touchcancel',this.onTouchEndSun,this);
            this.lightAni.active = true;
            // 刮风
            O1HD.getManagers().soundMgr.playSound("wind",(clip:cc.AudioClip)=>{},BUNDLE_SMALL_NAME.chooseConcubineGameBundle);
            this.hideglass();
            this.btns[this.curIndex].active = false;
            this.bgRemoveEvent();
            this.scheduleOnce(()=>{
                this.ConcubineContent.children.forEach((n:cc.Node)=>{
                    let ns = n.getComponent(chooseConcubineConcubine);
                    ns.changeState(1);
                });
            },2);
        }
    }

    async concubineRandSort(){
        this.scheduleOnce(()=>{
            this.changePauseTime(true);
        },0.1);
        // O1HD.getManagers().soundMgr.stopMusic();
        O1HD.getManagers().soundMgr.playMusic("changePos",BUNDLE_SMALL_NAME.chooseConcubineGameBundle);
        if(this.goTips){
            this.endStepShowShadow();
        }
        for(let i =0;i<20;i++){
            let oneRand = Math.floor(Math.random()*this.ConcubineContent.children.length);
            let twoRand = Math.floor(Math.random()*this.ConcubineContent.children.length);
            while(oneRand == twoRand){
                twoRand = Math.floor(Math.random()*this.ConcubineContent.children.length);
            }
            let oneNode:cc.Node = this.ConcubineContent.children[oneRand];
            let twoNode:cc.Node = this.ConcubineContent.children[twoRand];

            let onePos:cc.Vec2 = oneNode.getPosition().clone();
            let twoPos:cc.Vec2 = twoNode.getPosition().clone();

            await new Promise<void>(resolve=>{
                //@ts-ignore
                cc.tween(oneNode).to(0.5,{position:twoPos}).start();
                //@ts-ignore
                cc.tween(twoNode).to(0.5,{position:onePos}).call(resolve).start();
            });

        }
        O1HD.getManagers().soundMgr.playMusic("chooseConcubineBgm",BUNDLE_SMALL_NAME.chooseConcubineGameBundle);
        this.changePauseTime(false);
    }

    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeThis();
    }

    closeThis(){
        this.node.destroy();
        this.node.removeFromParent();
    }

    timeEnd(){
        // 时间结束之前未完成目标
        this.refrenshQuestion();
        this.refrenshTime();
        let data = {
            id: "51"
            , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
            , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
        }
        utilsView.openEventLayer(
            null
            , data
            , UI_Z_INDEX.DIALOG
        );
        this.changePauseTime(true);
    }

    update(dt: number): void {
        this.ConcubineContent.children.forEach((n:cc.Node)=>{
            n.zIndex = -n.y;
        });
    }

    openGlass(){
        if(this.glassNode.active){
            this.hideglass();
            // this.glassNode.off('touchmove',this.onTouchMoveGlass,this);
        }else{
            this.showGlass();
            // this.glassNode.on('touchmove',this.onTouchMoveGlass,this);

        }
    }

    showGlass(){
        this.glassNode.active = true;
        this.glassMaskNode.active = true;
        // this.initGlass();
    }

    hideglass(){
        this.glassMaskNode.active = false;
        this.glassNode.active = false;
        // this.initGlass();
    }

    initGlass(){
        this.glassNode.setPosition(cc.v2(15,-30));
        this.glassMaskNode.setPosition(cc.v2(0,0));
        this.glassBgNode.setPosition(0,0);
    }

    onTouchMoveGlass(e:cc.Event.EventTouch){
        let detal:cc.Vec2 = e.getDelta();
        let sDetal:cc.Vec2 = detal.mul(this.glassBgNode.scale);
        this.glassBgNode.x -= sDetal.x;
        this.glassBgNode.y -= sDetal.y;

        this.glassNode.x += detal.x;
        this.glassNode.y += detal.y;
        this.glassMaskNode.x += detal.x;
        this.glassMaskNode.y += detal.y;
    }

    changePauseTime(isPause:boolean){
        this.pauseTime = isPause;
    }

    showHint(){
        this.hintNode.active = true;
    }

    hideHint(){
        this.hintNode.active = false;
    }

    onBtnCloseHint(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.hideHint();
    }

    refrenshHintBtn(){
        this.hintVideo.active = !this.goTips;
    }

    onBtnHint(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if(this.goTips){
            this.showHint();
        }else{
            O1HD.getServices().miniGameSrv.getAppApiInstance().loadAndShowVideoAd(()=>{
                this.goTips = true;
                this.showHint();
                this.refrenshHintBtn();
                if(this.curIndex == 3){
                    this.endStepShowShadow();
                }
            },()=>{

            },null,"选妃看广告获得提示");
        }
    }

    endStepShowShadow(){
        this.ConcubineContent.children.forEach((n:cc.Node)=>{
            let ns = n.getComponent(chooseConcubineConcubine);
            if(ns.getConcubineType() == 0){
                ns.showShadow();
            }
        });
    }

}
